import React from 'react';
import { Link } from 'react-router-dom';

import ContactIcons from '../Contact/ContactIcons';

const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        <img src={`${PUBLIC_URL}/images/me.jpg`} alt="" />
      </Link>
      <header>
        <h2>Selva kumar Rajendran</h2>
        <p>
          <a href="mailto:selvakumar.rajendran2011@gmail.com">selvakumar.rajendran2011@gmail.com</a>
        </p>
      </header>
    </section>

    <section className="blurb">
      <h2>About</h2>
      <p>
        Hi, I&apos;m Selva. I am a{' '}
        <a href="/">Software Engineer</a>, at{' '}
        <a href="https://nagra.com">Nagra</a>. Previously, I
        worked on multiple tech stacks like AWS, Terraform, Jenkins, CICD
        Javascript, Python, React, HTML, CSS, Nodejs.
      </p>
      <ul className="actions">
        <li>
          {!window.location.pathname.includes('/resume') ? (
            <Link to="/resume" className="button">
              Learn More
            </Link>
          ) : (
            <Link to="/about" className="button">
              About Me
            </Link>
          )}
        </li>
      </ul>
    </section>

    <section id="footer">
      <ContactIcons />
      <p className="copyright">
        &copy; Selva kumar Rajendran <Link to="/">selvakumarrajendran.com</Link>.
      </p>
    </section>
  </section>
);

export default SideBar;
